import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-CurrentLocation",
  "use": "svg-icon-CurrentLocation-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-CurrentLocation\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 5.25L4.5 7.5 6.75 12 12 0 0 5.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol